import Grid from "@mui/material/Grid";
import makeStyles from "@mui/styles/makeStyles";
import styles from "assets/jss/Scan/scanStyle";
import CrmHelpButton from "components/Buttons/CrmHelpButton";
import error from 'assets/img/error.svg'
const useStyles = makeStyles(styles)

const NfcNotSupport = () => {
    const classes = useStyles()

    return(
        <Grid container>
            <Grid item className={classes.root} xs={12} mt='12px'>
                <img src={error} alt=''/>
            </Grid>
            <Grid item xs={12}>
                <p className={classes.noNfcText}>
                    موبایل شما از قابلیت NFC پشتیبانی نمی کند<br/>
                    و امکان اسکن با این موبایل وجود ندارد.
                </p>
            </Grid>
            <Grid item xs={12}>
                <p className={classes.noNfcHelpText}>
                    با یک موبایل دیگر که دارای قابلیت NFC است اسکن کنید یا از پزشک خود کمک بگیرید.
                </p>
            </Grid>
            <Grid className={classes.helpContainer} mt={'51px'} container>
                <div className={classes.lineScan}/>
                <CrmHelpButton text={true}/>
            </Grid>
        </Grid>
    )
}
export default NfcNotSupport